import React, { useRef, useLayoutEffect } from 'react'
import { Box } from '@mui/material'
import PopularGames from './popularGames/popularGames'
import NewlyLaunched from './newlyLaunched/newlyLaunched'
import LiveGames from './liveGames/liveGames'
import { initPopularGamesAnimations } from '../animations'

export const Games = (props) => {
    const sectionRef = useRef(null);
    const newlyAddedSectionRef = useRef(null);
    const liveSectionRef = useRef(null);

    useLayoutEffect(() => {
        const cleanup = initPopularGamesAnimations({
            sectionRef,
            newlyAddedSectionRef,
            liveSectionRef,
        });
        return cleanup;
    }, []);

    return (
        <Box>
          {/* Popular games Section  */}
          <Box ref={sectionRef} sx={{ width: "100%", position: "relative", zIndex: 6, bgcolor: "background.default" }}>
              <PopularGames {...props} />
          </Box>

          {/* Newly Added Section */}
          <Box ref={newlyAddedSectionRef} sx={{ width: "100%", position: "relative", zIndex: 8, bgcolor: "background.default" }}>
            <NewlyLaunched />
          </Box>
     
          {/* Live Games Section */}
           <Box ref={liveSectionRef} sx={{ width: "100%", position: "relative", zIndex: 10, bgcolor: "background.default" }}>
             <LiveGames {...props} />
           </Box>
        </Box>
    )
}